<template>
    <PopupRouterViewDetail label="Machine Detail" @hideMethod="onHidden" :isShowCopyData="false">

        <!-- APP_DETAIL_HEADER -->

        <b-card header="Machine" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-input-textbox id="fieldset-code" label-cols-lg="12"  label="Code" label-for="input-code" size="sm" :model.sync="model.code" :isRequired="true" :state="validateState('code')" :errorMessage="getErrorMessage(errorMessage.code, 'code')"  @change="updateData"  :isUpdatable="true" />
						<app-input-textbox id="fieldset-name" label-cols-lg="12"  label="Name" label-for="input-name" size="sm" :model.sync="model.name" :isRequired="true" :state="validateState('name')" :errorMessage="getErrorMessage(errorMessage.name, 'name')"  @change="updateData"  :isUpdatable="true" />
						<app-input-textbox id="fieldset-tonase" label-cols-lg="12"  label="Tonase" label-for="input-tonase" size="sm" :model.sync="model.tonase"  @change="updateData"  :isUpdatable="true"  :thousandSeparator="false" />
						<app-input-combobox-autocomplete :options="productionControlTimes" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="Production Control Time" id="fieldset-production-control-time" size="sm" :model.sync="model.productionControlTimeId"   :selected="model.productionControlTime != null ? model.productionControlTime.name : ''" @input="getProductionControlTimes" @change="updateData"  :isUpdatable="true"  :isSelectMethodExists="true" @onSelectMethod="setSelectedProductionControlTime"  />
					</b-col>
					<b-col cols="12" lg="6">
						<app-input-textbox id="fieldset-sph" label-cols-lg="12"  label="Stroke Per Hour" label-for="input-sph" size="sm" :model.sync="model.sph"  @change="updateData"  :isUpdatable="true"  :thousandSeparator="false" />
						<app-input-combobox-autocomplete :options="lines" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Line Code" id="fieldset-line-code" size="sm" :model.sync="model.lineCodeId"   :selected="model.lineCode != null ? model.lineCode.code : ''" @input="getLines" @change="updateData"  :isUpdatable="true"  :isSelectMethodExists="true" @onSelectMethod="setSelectedLineCode" />
						<app-input-textarea id="fieldset-remark" label-cols-lg="12"  label="Remarks" label-for="input-remark" size="sm" :model.sync="model.remark"  @change="updateData"  :isUpdatable="true" />
				</b-col>

            </b-row>
        </b-card>

		<PopupPDF :openPopup="isShowPopupPDF" :pdfUrl="pdfUrl" @resetModalMethod="resetModal"
				label="Print QR" />
		<template #modal-left-button>
			<b-button @click="printQr()" size="sm" class="float-right" variant="primary">
              Print QR
            </b-button>
        </template>
        <!-- END_APP_DETAIL_HEADER -->
        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterViewDetail>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import Machine from '@/models/Machine/Machine';
import MachineList from '@/models/Machine/MachineList';
import MachineFilter from '@/filters/Machine/MachineFilter';
import PopupPDF from '@/components/PopupPDF';
import PrintQr from '@/models/PrintQr/PrintQr';

import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';

import AppInputTextbox from '@/components/AppInputTextboxNumberCustom';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import ProductionControlTime from '@/models/ProductionControlTime/ProductionControlTime';
import ProductionControlTimeFilter from '@/filters/ProductionControlTime/ProductionControlTimeFilter';
import Line from '@/models/Line/Line';
import LineFilter from '@/filters/Line/LineFilter';
import AppInputTextarea from '@/components/AppInputTextarea';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppInputTextbox,
		AppInputComboboxAutocomplete,
		AppInputTextarea,
		PopupRouterViewDetail,
		PopupRouterView,
		PopupPDF,
	},
	mixins : [validationMixin],
	validations: {
		model: {
			code: {required},
			name: {required},
		},
	},
	data() {
		return {
			errorMessage : {
				code: { required : "Code is Required."},
				name: { required : "Name is Required."},
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			filterMachine : null,
			currentMachinePage : 1,
			machinePageSize: 10,
			sortByMachine: '',
			sortDescMachine: '',
			productionControlTimes: [],
			productionControlTimes: [],
			isProductionControlTimeComboLoading: false,
			lines: [],
			lineCodes: [],
			isLineCodeComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isProductionControlTimeComboLoading: false,
			isLineComboLoading: false,
			isShowPopupPDF: false,
			pdfUrl: ''
		}
	},
	methods : {
		printQr: async function(){
			try {
				this.isBusy = true;
				this.isShowPopupPDF = false;
				var result = await PrintQr.printQr(this, this.modelId, "MACHINE");
				this.isShowPopupPDF = true;
				this.pdfUrl = result.download;	
				this.isBusy = false;
			} catch {
				this.isBusy = false;
			}	
		},
		getMachine : async function(id) {
			this.isBusy = true;
			Machine.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadMachine = true;
			this.filterMachine.id = this.modelId;
			Machine.downloadDataDetail(this, this.filterMachine).then(result => {
				this.isDownloadMachine = false;
			}).catch(error => { this.isDownloadMachine = false; })
		},
		getMachines : async function(input) {
			let filter = new MachineFilter();
			if (input != undefined) {
				filter.Code = input;
			}
			this.isMachineComboLoading = true;
			Machine.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.machines = result.data
				}
				this.isMachineComboLoading = false;
			})
			.catch(error => {});
		},
		getProductionControlTimes : async function(input) {
			let filter = new ProductionControlTimeFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ProductionControlTime.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.productionControlTimes = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedProductionControlTime(item) {
			if(item == undefined || item == null) {
				this.model.productionControlTimeId = null;
				this.model.productionControlTime = null;
			} else {
				this.model.productionControlTimeId = item.id;
				this.model.productionControlTime = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getLines : async function(input) {
			let filter = new LineFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Line.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.lines = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedLineCode(item) {
			if(item == undefined || item == null) {
				this.model.lineCodeId = null;
				this.model.lineCode = null;
			} else {
				this.model.lineCodeId = item.id;
				this.model.lineCode = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.machineInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				let promises = Array();

				Promise.all(promises).then((results) => {
					if (id != '' && id != null && id != undefined) {
						Machine.updateData(this, model, id).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'machineindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						Machine.insertData(this, model).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'machineindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					}
				});
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					Machine.updateDataDetail(this, model, id)
					.catch((error) => {
						this.getMachine(id);
					});
				}
			});
		},
		onHidden() {
			this.getMachines();
		},
		resetModal(modalType) {
			this.isShowPopupPDF = false;
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
	},
	beforeMount() {
		this.filterMachine = new MachineFilter();
		//this.getProductionControlTimes();
		//this.getLines();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getMachine(id);
			} else {
				this.modelId = id;
				this.getMachine(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				if(this.model.mainRecordId != undefined || this.model.mainRecordId != null) return false;
				return true;
			}
		}
	},
	watch : {
	},
}
</script>
